import { useLocation, useParams } from "react-router-dom";
import DownMouse from "../components/downMouse";
import izosistem from "../static files/images/izosistem-2.jpg";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getPortfolioById } from "../slices/portfolioReducer";
import { getBlogById } from "../slices/blogReducer";
import Loading from "../components/Loading";
import NotFound from "./Notfound";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const ProjectDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const { selectedPortfolio, status, error } = useSelector(
    (state) => state.portfolio,
  );
  const { selectedBlog, detailStatus, detailError } = useSelector(
    (state) => state.blogs,
  );
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("project")) {
      dispatch(getPortfolioById(id));
    } else if (location.pathname.includes("blog")) {
      dispatch(getBlogById(id));
    }
  }, [dispatch, id]);

  // ✅ Hər iki data üçün bir dəyişən
  const displayData = selectedBlog || selectedPortfolio;
  const images = displayData?.media?.filter((m) => m.type === "image") || [];

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return; // lightbox açıq deyilsə işləməsin

      if (e.key === "ArrowRight") {
        setCurrentIndex((prev) => (prev + 1) % images.length);
      }

      if (e.key === "ArrowLeft") {
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
      }

      if (e.key === "Escape") {
        setIsOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, images.length]);

  if (status === "loading" || detailStatus === "loading") {
    return <Loading />;
  }

  if (status === "failed") {
    return <NotFound />;
  }

  if (detailStatus === "failed") {
    return <NotFound />;
  }

  if (!displayData) {
    return <NotFound />;
  }

  return (
    <main className="project-detail-main">
      <section className="project-detail-hero">
        <h1>{displayData?.title}</h1>
        <article style={{ whiteSpace: "pre-line" }}>
          {displayData?.about}
        </article>

        {/* <div className="down-mouse">
          <DownMouse />
        </div> */}
      </section>

      <section className="images-section">
        <div className="section-body">
          <ul className="image-ul">
            {images?.map((item, index) => (
              <li key={index}>
                <img
                  src={item.url}
                  alt=""
                  onClick={() => {
                    setCurrentIndex(index);
                    setIsOpen(true);
                  }}
                  style={{ cursor: "pointer" }}
                />
              </li>
            ))}
          </ul>

          {isOpen && (
            <div className="lightbox">
              <a className="x-button" onClick={() => setIsOpen(false)}>
                ✕
              </a>

              <button
                className="left-button"
                onClick={() =>
                  setCurrentIndex(
                    (currentIndex - 1 + images.length) % images.length,
                  )
                }
              >
                ◀
              </button>

              <img src={images[currentIndex].url} />

              <button
                className="right-button"
                onClick={() =>
                  setCurrentIndex((currentIndex + 1) % images.length)
                }
              >
                ▶
              </button>
            </div>
          )}

          <h2>{displayData?.title} – Layihədən Görüntülər</h2>

          <ul className="video-ul">
            {displayData?.media
              ?.filter((item) => item.type === "video")
              .map((item, index) => (
                <li>
                  <video
                    controls
                    autoPlay={false}
                    playsInline
                    muted
                    preload="metadata"
                  >
                    <source src={item.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </li>
              ))}
          </ul>
        </div>
      </section>

      <section className="location-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1659.649211303713!2d49.85986073375978!3d40.39249117023704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d152bd7d73b%3A0x92a47a0852f48752!2zOTUgUWFyYWJhxJ8ga8O8w6fJmXNpLCBCYWvEsQ!5e0!3m2!1saz!2saz!4v1758971556771!5m2!1saz!2saz"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
    </main>
  );
};

export default ProjectDetail;
